'use strict';

class RcmFatProfileForm {
    constructor(fat) {
        this.fat = fat;

        // Selectors
        this.selector = '.fatv2-profile-form';
        this.submitSelector = '#fatv2-contact-submit';
        this.requiredFieldsSelector = '#fatv2-first_name, #fatv2-last_name, #fatv2-subject, #fatv2-teachernumber, #fatv2-teacherfullname, #fatv2-message, #fatv2-lessonsfor, #fatv2-level, #fatv2-instruments';
        this.emailSelector = '#fatv2-email, #fatv2-email-confirm';
        this.postalCodeSelector = '#fatv2-postal-code';
        this.phoneSelector = '#fatv2-phone';
        this.messageSelector = '#fatv2-message';
        this.topQuestionsSelector = '#fatv2-top_questions';
        this.touSelector = '#fatv2-tou';
        this.captchaSelector = 'textarea[name="g-recaptcha-response"]';
        this.formInnerSelector = '.fatv2-profile-form-inner';
        this.formFeedbackSelector = '.fatv2-profile-form-feedback';
    }

    // Get form HTML
    get(data, formDisabled) {
        // HTML variables
        var preMessage = 'Hello. I’d like to learn more about signing up for music lessons with you. Could you please tell me how much lessons cost and how they are scheduled? Thank you.';
        var topQuestions = 'By submitting this form, I agree to receive teacher correspondence and other RCM communications, including <strong>"Top 10 Interview Questions to Ask Music Teachers"</strong>. I understand that I am free to unsubscribe at any time.';
        var touText = 'By submitting this message, I agree with the Find a Teacher <a href="/study-rcm/terms-of-use" target="_blank">Terms of Use</a>';

        var html = "";

        if (data.acceptingNewStudents) {
            html = `<div class="fatv2-profile-form" style="display:${formDisabled ? "none" : "block"}">
                    <p class="h3 fatv2-profile-form-label">Contact ${data.firstName}</p>
                    <div class="fatv2-profile-form-inner">
                        <input name="teachernumber" id="fatv2-teachernumber" type="hidden" value="${data.objectID}">
                        <input name="teacherfullname" id="fatv2-teacherfullname" type="hidden" value="${data.fullName}">
                        <input name="subject" id="fatv2-subject" type="hidden" value="RCM Music Teacher Inquiry">
                        <input name="phone" id="fatv2-phone" type="hidden" value="" maxlength="254">
                        <fieldset class="fatv2-form-fieldset">
                            <legend class="fatv2-form-legend">Find an RCM teacher near you</legend>
                            <div class="fatv2-form-row">
                                <label class="fatv2-form-label" for="fatv2-first_name">First name</label>
                                <input class="form-text" id="fatv2-first_name" name="first_name" type="text" placeholder="Required field" maxlength="128">
                            </div>
                            <div class="fatv2-form-row">
                                <label class="fatv2-form-label" for="fatv2-last_name">Last name</label>
                                <input class="form-text" id="fatv2-last_name" name="last_name" type="text" placeholder="Required field" maxlength="128">
                            </div>
                            <div class="fatv2-form-row">
                                <label class="fatv2-form-label" for="fatv2-email">Email</label>
                                <input class="form-text" id="fatv2-email" name="email" type="email" placeholder="Required field" maxlength="254">
                            </div>
                            <div class="fatv2-form-row">
                                <label class="fatv2-form-label" for="fatv2-email-confirm">Confirm your email</label>
                                <input class="form-text" id="fatv2-email-confirm" name="email_confirm" type="email" placeholder="Required field" maxlength="254">
                            </div>
                            <div class="fatv2-form-row">
                                <label class="fatv2-form-label" for="fatv2-postal-code">Postal code/Zip code</label>
                                <input class="form-text" id="fatv2-postal-code" name="postal_code" type="text" maxlength="254">
                            </div>
                            <div class="fatv2-form-row">
                                <label class="fatv2-form-label" for="fatv2-lessonsfor">I am interested in lessons for:</label>
                                <select class="form-select" id="fatv2-lessonsfor" name="lessonsfor" required>
                                    <option selected disabled value="">Select</option>
                                    <option value="Myself">Myself</option>
                                    <option value="My child">My child</option>
                                    <option value="Other">Other</option>
                                </select>
                            </div>
                            <div class="fatv2-form-row">
                                <label class="fatv2-form-label" for="fatv2-level">The student’s level of musical experience is:</label>
                                <select class="form-select" id="fatv2-level" name="level" required>
                                    <option selected disabled value="">Select</option>
                                    <option value="Beginner">Beginner</option>
                                    <option value="Intermediate">Intermediate</option>
                                    <option value="Advanced">Advanced</option>
                                </select>
                            </div>
                            <div class="fatv2-form-row">
                                <label class="fatv2-form-label" for="fatv2-instruments">The instrument(s) the student wants to study is (are):</label>
                                <select class="form-select" id="fatv2-instruments" name="instruments" required><option selected disabled value="">Select</option><option value="Accordion">Accordion</option><option value="Analysis">Analysis</option><option value="Bassoon">Bassoon</option><option value="Clarinet">Clarinet</option><option value="Composition">Composition</option><option value="Counterpoint">Counterpoint</option><option value="Double Bass">Double Bass</option><option value="Euphonium">Euphonium</option><option value="Flute">Flute</option><option value="French Horn">French Horn</option><option value="Guitar">Guitar</option><option value="Harmony">Harmony</option><option value="Harp">Harp</option><option value="Harpsichord">Harpsichord</option><option value="History">History</option><option value="Oboe">Oboe</option><option value="Organ">Organ</option><option value="Percussion">Percussion</option><option value="Piano">Piano</option><option value="Piano Pedagogy">Piano Pedagogy</option><option value="Recorder">Recorder</option><option value="Rudiments">Rudiments</option><option value="Saxophone">Saxophone</option><option value="Speech &amp; Drama">Speech &amp; Drama</option><option value="Theory">Theory</option><option value="Trombone">Trombone</option><option value="Trumpet">Trumpet</option><option value="Tuba">Tuba</option><option value="Viola">Viola</option><option value="Violin">Violin</option><option value="Violoncello">Violoncello</option><option value="Voice">Voice</option></select>
                            </div>
                            <div class="fatv2-form-row">
                                <label class="fatv2-form-label" for="fatv2-message">Send ${data.firstName} a Message <small>Use our message or write your own! REMINDER: Do not include private or sensitive information in your message.</small></label>
                                <textarea class="form-textarea" id="fatv2-message" name="message" rows="5" cols="60">${preMessage}</textarea>
                            </div>
                            <div class="fatv2-form-row">
        	                    <input class="form-checkbox" id="fatv2-top_questions" name="top_questions" type="checkbox" value="1">
        	                    <label class="fatv2-form-label" for="fatv2-top_questions">${topQuestions}</label>
                            </div>
                            <div class="fatv2-form-row">
        	                    <input class="form-checkbox" id="fatv2-tou" name="terms_of_use" type="checkbox" value="1">
        	                    <label class="fatv2-form-label" for="fatv2-tou">${touText}</label>
                            </div>
                            <div class="fatv2-form-row fatv2-button-wrapper">
                                <input class="button fatv2-button fatv2-button-submit" id="fatv2-contact-submit" type="submit" value="Send">
                            </div>
                        </fieldset>
                    </div>
                    <div class="fatv2-profile-form-feedback hide"></div>
                </div>`;
            if (formDisabled) {
                html += `<div class="fatv2-profile-form">
                    <p class="h3 fatv2-profile-form-label">Contact ${data.firstName}</p>
                    <div style="background-color:#f9f0f0;border:.0625rem solid #960000;color:#960000;padding:1.25rem;width:fit-content;">This form is temporarily unavailable due to scheduled maintenance. Normal service will resume on Friday, October 6, 2023. We apologize for the inconvenience and thank you for your patience.</div>
                </div>`;
            }
        } else {
            html = `<div class="fatv2-profile-form">
                        <p class="h3 fatv2-profile-form-label">Contact ${data.firstName}</p>
                        <p class="fatv2-profile-accepting-students"><i class="fas fa-info-circle"></i> ${data.firstName}  is not currently taking students.</p>
                    </div>`;
        }

        html = $(html);
        return html;
    }

    // Is form valid
    isFormValid() {
        var valid = true;

        // Required fields
        $(this.requiredFieldsSelector).each(function () {
            $(this).trigger('change_custom');
        });
        if ($(this.requiredFieldsSelector).filter(function () { return $(this).parent().hasClass('Error') }).length > 0) {
            valid = false;
        }

        // Email field
        $(this.emailSelector).each(function () {
            $(this).trigger('change_custom');
        });
        if ($(this.emailSelector).filter(function () { return $(this).parent().hasClass('Error') }).length > 0) {
            valid = false;
        }

        // Message field
        $(this.messageSelector).each(function () {
            $(this).trigger('change_custom');
        });
        if ($(this.messageSelector).filter(function () { return $(this).parent().hasClass('Error') }).length > 0) {
            valid = false;
        }

        // Stop here if the previous validations are not true
        if (!valid) {
            return valid;
        }

        // Tor questions field
        $(this.topQuestionsSelector).each(function () {
            $(this).trigger('change_custom');
        });
        if ($(this.topQuestionsSelector).filter(function () { return $(this).parent().hasClass('Error') }).length > 0) {
            valid = false;
        }

        // TOU field
        $(this.touSelector).each(function () {
            $(this).trigger('change_custom');
        });
        if ($(this.touSelector).filter(function () { return $(this).parent().hasClass('Error') }).length > 0) {
            valid = false;
        }

        // Stop here if the previous validations are not true
        if (!valid) {
            return valid;
        }

        // Captcha
        if (!grecaptcha.getResponse(this.fat.google.captchaWidgetId)) {
            alert('Please, check the option "I\'m not a robot" before continue.');
            valid = false;
        }

        return valid;
    }

    showFeedback(message, calloutClass, hideFormInner = false) {
        if (hideFormInner) {
            $(this.formInnerSelector).addClass('hide');
        }

        $(this.formFeedbackSelector).html(message).addClass(calloutClass).removeClass('hide');
    }

    hideFeedback() {
        $(this.formFeedbackSelector).html('').attr('class', 'fatv2-profile-form-feedback hide');
        $(this.formInnerSelector).removeClass('hide');
    }

    scrollToFieldWithError() {
        var invalidFields = $(this.selector).find('.fatv2-form-row.Error');
        if (invalidFields && invalidFields.length > 0) {
            TPS.Utility.smoothScroll(invalidFields[0]);
        }
    }
}
